import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import SocketProgressBar from '@/app/common/components/SocketProgressBar';
import keywordPlannerApi from '@/app/KeywordResearch/api/keywordPlannerApi';

type PlannerProgressBarProps = {
  taskId: string;
  active: boolean;
  onComplete?: () => void;
  description?: string;
};

const PlannerProgressBar = ({
  taskId,
  active,
  onComplete,
  description
}: PlannerProgressBarProps) => {
  const dispatch = useDispatch();

  const revalidatePlannerDetails = useCallback(() => {
    dispatch(
      keywordPlannerApi.util.invalidateTags([
        { type: 'PlannerDetails', id: taskId },
        'PlannerHistory'
      ])
    );
  }, [dispatch, taskId]);

  const handleComplete = () => {
    revalidatePlannerDetails();
    onComplete?.();
  };

  if (!taskId) return null;

  return (
    <SocketProgressBar
      channelId={taskId}
      active={active}
      onComplete={handleComplete}
      description={description}
    />
  );
};

export default PlannerProgressBar;
